import { uuidEquals } from 'calling-cross-tab-library/appData/operators/uuidEquals';
export const updateWidgetDetailsFromWorker = (appData, widgetDetails) => {
  const mergedAppData = appData;
  const updates = [];
  if (!uuidEquals(appData.widgetDetails, widgetDetails)) {
    mergedAppData.widgetDetails = widgetDetails;
    updates.push('widgetDetails');
  }
  return {
    result: mergedAppData,
    updates
  };
};
export const updateDataFromWorker = (appData, nextAppData) => {
  const mergedAppData = appData;
  const updates = [];
  mergedAppData.version = nextAppData.version;
  if (!uuidEquals(appData.widgetDetails, nextAppData.widgetDetails)) {
    mergedAppData.widgetDetails = nextAppData.widgetDetails;
    updates.push('widgetDetails');
  }
  return {
    result: mergedAppData,
    updates
  };
};
export const updateProviderDetailsFromWorker = (appData, providerDetails) => {
  const mergedAppData = appData;
  const updates = [];
  if (!uuidEquals(appData.providerDetails, providerDetails)) {
    mergedAppData.providerDetails = providerDetails;
    updates.push('providerDetails');
  }
  return {
    result: mergedAppData,
    updates
  };
};